import React, { useState } from 'react';
import {
  makeStyles, Container, Grid, Typography, Box,
  IconButton, Dialog, DialogContent,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Image from 'next/image';
import GetStartedBtn from 'components/ListYourBike/GetStartedBtn';
import howRenting from '../../public/imgs/list-your-bike/how_renting.webp';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    position: 'relative',
    [theme.breakpoints.up('lg')]: {
      height: theme.spacing(52),
    },
  },
  headerImgBox: {
    height: theme.spacing(34),
    overflow: 'hidden',
    position: 'relative',
    [theme.breakpoints.only('md')]: {
      height: theme.spacing(48),
    },
    [theme.breakpoints.up('lg')]: {
      position: 'absolute',
      zIndex: 0,
      height: theme.spacing(48),
      top: theme.spacing(2.5),
      right: 0,
      width: '46%',
      borderRadius: '35px 0 0 35px',
    },
  },
  headerImg: {
    height: '100%  !important',
    position: 'absolute',
    zIndex: 0,
    top: '0px !important',
    left: '0px !important',
    right: 'auto !important',
    bottom: 'auto !important',
    width: 'auto !important',
    minWidth: '100% !important',
    maxHeight: 'none !important',
    [theme.breakpoints.only('md')]: {
      width: '100% !important',
      height: 'auto !important',
      minHeight: '100% !important',
      top: `${theme.spacing(-7)} !important`,
    },
    [theme.breakpoints.up('lg')]: {
      width: '100% !important',
      height: 'auto !important',
      minHeight: '100% !important',
      margin: '0 !important',
      top: '50% !important',
      left: '50% !important',
      transform: 'translate(-50%, -50%)',
    },
  },
  welcomeTxt: {
    marginTop: theme.spacing(4),
    [theme.breakpoints.only('sm')]: {
      textAlign: 'center',
    },
    [theme.breakpoints.only('md')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: 0,
      maxWidth: '85%',
    },
  },
  mainTitle: {
    fontSize: theme.typography.pxToRem(32),
    marginBottom: theme.spacing(3),
    fontWeight: 'bolder',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(36),
      marginBottom: theme.spacing(3),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.typography.pxToRem(48),
      marginBottom: theme.spacing(4),
    },
  },
  subTxt: {
    fontSize: theme.typography.pxToRem(22),
    fontWeight: '300',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(24),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.typography.pxToRem(30),
    },
  },
  amount: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(22),
    cursor: 'pointer',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(24),

    },
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.typography.pxToRem(30),
    },
  },
  getStartedBtn: {
    marginTop: theme.spacing(4.25),
    fontSize: theme.typography.pxToRem(16),
    fontWeight: '500',
    borderRadius: 10,
    padding: theme.spacing(0.75, 2),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(20),
      padding: theme.spacing(1, 8),
      marginTop: theme.spacing(5.5),
      width: 'auto',
    },
  },
  dialog: {
    borderRadius: 15,
    maxWidth: theme.spacing(86.25),
    [theme.breakpoints.only('sm')]: {
      margin: theme.spacing(1.5),
    },
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  closeIcn: {
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(36),
    },
  },
  dialogContent: {
    textAlign: 'center',
    padding: theme.spacing(6, 0, 5),
    fontSize: theme.typography.pxToRem(16),
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(24),
      padding: theme.spacing(8.5, 5, 6.25),
      lineHeight: theme.typography.pxToRem(30),
    },
  },
}));

const WelcomeBanner = ({ i18n }) => {
  const classes = useStyles();

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Box className={classes.mainContainer}>

        <Box className={classes.headerImgBox}>
          <Image
            className={classes.headerImg}
            src={howRenting}
            alt="Rent Your Motorcycle"
            layout="fill"
            placeholder="blur"
            unoptimized
            priority
          />
        </Box>

        <Container>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={6} className={classes.contentGrid}>
              <Box className={classes.welcomeTxt}>
                <Typography variant="h1" classes={{ root: classes.mainTitle }}>
                  {i18n('fe_list_your_bike:rent_your_motorcycle')}
                </Typography>
                <Typography
                  classes={{ root: classes.subTitle }}
                  variant="h3"
                >
                  <Typography
                    component="span"
                    classes={{ root: classes.subTxt }}
                  >
                    {i18n('fe_list_your_bike:earn_up_to_1')}
                  </Typography>
                  <Typography
                    component="a"
                    classes={{ root: classes.amount }}
                    onClick={handleClickOpen}
                  >
                    {i18n('fe_list_your_bike:earn_up_to_2')}
                  </Typography>
                  <Typography
                    component="span"
                    classes={{ root: classes.subTxt }}
                    dangerouslySetInnerHTML={{
                      __html: i18n('fe_list_your_bike:earn_up_to_3'),
                    }}
                  />
                </Typography>
                <GetStartedBtn
                  i18n={i18n}
                  styleClass={classes.getStartedBtn}
                />
              </Box>
            </Grid>

          </Grid>
        </Container>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        classes={{ paper: classes.dialog }}
      >
        <DialogContent>
          <IconButton className={classes.closeButton} onClick={handleClose}>
            <CloseIcon className={classes.closeIcn} />
          </IconButton>
          <Typography classes={{ root: classes.dialogContent }}>
            {i18n('fe_list_your_bike:earn_details')}
          </Typography>
        </DialogContent>
      </Dialog>

    </>
  );
};

export default WelcomeBanner;
